import React from "react";

const GallerySection = ({ galleryImages, handleImageClick }) => {
  return (
    <section className="py-24 scroll-animation opacity-0 translate-y-8 transition-all duration-800 ease-out">
      <div className="container mx-auto px-6">
        <h2 className="text-center text-4xl md:text-5xl font-bold text-white mb-16">
          Discover Your Next Destination
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 md:grid-rows-2 gap-6 h-[70vh]">
          {galleryImages.map((item, index) => {
            const gridClass =
              index === 0 ? "md:col-span-2 md:row-span-2" : "md:col-span-1";
            const cursorClass = index !== 0 ? "cursor-pointer" : "";
            return (
              <div
                key={item.id}
                className={`relative rounded-2xl overflow-hidden group shadow-lg ${gridClass} ${cursorClass}`}
                onClick={() => handleImageClick(index)}
              >
                <img
                  src={item.image}
                  alt={item.alt}
                  loading="lazy"
                  className="w-full h-full object-cover block transition-transform duration-500 ease-in-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 p-6 w-full">
                  <h3 className="text-white text-2xl font-semibold opacity-0 group-hover:opacity-100 transition-all duration-500">
                    {item.title}
                  </h3>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
